import { Fetch } from "../apiConfig/Fetch";
import { ApiConfig } from "../apiConfig/apiConfig";
import { asyncStoreGet } from "../../ui/Utils/asyncStorage";
import { TOKEN_KEY } from "../../ui/contants/authKeys";

/**
 * Helper to get stored authentication token
 */
const getAuthToken = async () => {
    try {
        return await asyncStoreGet(TOKEN_KEY);
    } catch (e) {
        console.warn('[MediaService] Failed to get token:', e);
        return null;
    }
};

/**
 * Helper to create headers with Authorization token for protected endpoints
 */
const getHeaders = async () => {
    const token = await getAuthToken();
    const headers = new Headers({
        "Content-Type": "application/json",
    });
    if (token) {
        headers.append("Authorization", `Bearer ${token}`);
    }
    return headers;
};

const MediaService = {
    getMediaList: async () => {
        const { baseUrl, getMediaList } = ApiConfig;

        const url = baseUrl + getMediaList;
        console.log('url');
        console.log(url)
        const headers = new Headers({
            "Content-Type": "application/json",
        });

        const mediaServicePromise = await Fetch(
            url,
            "GET",
            headers,
            '',
            "services_opening",
            true
        );
        console.log("mediaServicePromise", mediaServicePromise)
        return mediaServicePromise;
    },

    insertOrUpdate: async (data) => {
        const { baseUrl, insertORUpdateMedia } = ApiConfig;
        console.log("insertORUpdateMedia", insertORUpdateMedia)
        const url = baseUrl + insertORUpdateMedia;
        
        const headers = await getHeaders();
        console.log("url", url)
        
        // Log Authorization header for debugging
        const authHeader = headers.get("Authorization");
        console.log("[MediaService] Authorization header present?", !!authHeader);
        if (authHeader) {
            console.log("[MediaService] Authorization:", authHeader.substring(0, 20) + "...");
        }
        
        // Log all headers
        console.log('[MediaService] Full request headers:', {
            'Content-Type': headers.get('Content-Type'),
            'Authorization': authHeader ? authHeader.substring(0, 30) + '...' : 'NOT SET'
        });
        
        // Backend extracts userId from authentication token via req.user
        // Do NOT send userId in the body - backend will reject it or ignore it safely
        const params = JSON.stringify({
            id: data.id || "",
            title: data.title,
            mediaList: data.mediaList
        });
        
        console.log('[MediaService] Request body:', {
            id: data.id || "",
            title: data.title,
            mediaListLength: data.mediaList ? data.mediaList.length : 0
        });

        const mediaServicePromise = await Fetch(
            url,
            "POST",
            headers,
            params,
            "services_openingService",
            true
        );
        
        console.log('[MediaService] Raw response:', {
            success: mediaServicePromise.success,
            status: mediaServicePromise.status,
            error: mediaServicePromise.error,
            message: mediaServicePromise.response?.message || 'N/A'
        });
        
        return mediaServicePromise;
    },
    
    enableDisableMedia: async (data) => {
        const { baseUrl, enableDisableMedia } = ApiConfig;
        const url = baseUrl + enableDisableMedia;
        
        const headers = await getHeaders();
        
        const params = JSON.stringify({
            id: data.id,
            status: `${data.status}`,
        });

        const enableDisableMediaPromise = await Fetch(
            url,
            "POST",
            headers,
            params,
            "services_enableDisableMediaPromise",
            true
        );
        return enableDisableMediaPromise;
    },
}

export default MediaService;